module.exports = __webpack_public_path__ + "static/terra-mattress-3-e95d8a20113139a46a2c99955de48631.png";